import { motion } from "framer-motion";

// Subtle, purposeful scroll reveal. No parallax, no kinetic effects.
export const Reveal = ({ children, delay = 0, className = "", y = 24 }) => {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.6, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </motion.div>
  );
};

export default Reveal;
